<div hsg-modal-header *ngIf="data.title">
	<h3>{{ data.title }}</h3>
	<a class="modal-close-icon cancel" hsgModalClose>
		<span class="icon-cross"></span>
	</a>
</div>
<div hsg-modal-body>
    <h3>{{ data.costCenter.name }}</h3>
    <table>
        <ul *ngFor="let missingBlock of data.missingBlocks">
            <li>
                <a class="button" [hsgModalClose]="true" [routerLink]="routerLink()" [queryParams]="queryParams(missingBlock)">
                    {{format(missingBlock)}}
                </a>
            </li>
        </ul>
    </table>
</div>
<div hsg-modal-footer>
	<button class="primary" [hsgModalClose]="true">
		{{ data.acceptText || 'OK' }}
	</button>
	<button class="cancel" [hsgModalClose]="false" *ngIf="data.rejectText">
		{{ data.rejectText }}
	</button>
</div>